import { MutableRefObject } from 'react'

import { generateId } from 'core-components/helpers/generateId'

import { IValidationProcess, TChangeStatus } from '../models/IBaseValidation'
import { IValidateResult, ValidationStatus } from '../models/IValidationStatus'
import { IValidatorProps, TCheckFn } from '../models/IValidatorProps'

interface IValidation {
  currentIdRef: MutableRefObject<string>
  checkFn: TCheckFn
  value: IValidatorProps['value']
  validationProcess: IValidationProcess
  changeStatus: TChangeStatus
  setText: (text: string) => void
}

export const baseValidation = (props: IValidation) => {
  const { currentIdRef, checkFn, validationProcess, changeStatus, setText } = props
  currentIdRef.current = generateId('validator')
  const startsWithId = currentIdRef.current

  const validProcess = new Promise<IValidateResult>((resolve) => {
    checkFn(props.value)
      .then((result) => {
        if (currentIdRef.current === startsWithId) {
          const newStatus = !result ? ValidationStatus.Valid : ValidationStatus.Invalid
          changeStatus(newStatus, result, (r) => resolve(r))
          setText(result)
          validationProcess.timeout = 0
        }
      })
      .catch((e) => {
        if (currentIdRef.current === startsWithId) {
          changeStatus(ValidationStatus.Invalid, e.message, (r) => resolve(r))
          validationProcess.timeout = 0
        }
      })
  })
  validationProcess.callback?.process(validProcess)
  return validProcess
}
